import { useAuth } from '@fluentsms/auth';
import { resetWsClient, setApolloLink } from '../client';
import { useEffect, useRef } from 'react';

export const useRenewApolloLinkWhenTokensRenewed = () => {
  const { addGlobalRenewTokenCallback } = useAuth();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      addGlobalRenewTokenCallback(() => {
        console.log('Renewing Apollo Link...');
        resetWsClient();
        setApolloLink();
        console.log('Apollo Link Renewed.');
      });
      initialized.current = true;
    }
  }, [addGlobalRenewTokenCallback]);
};
